import Vue from 'vue'
import VueFlatPickr from 'vue-flatpickr-component';

Vue.use(VueFlatPickr);